import { render, staticRenderFns } from "./BasePotentialBidder.vue?vue&type=template&id=6c058d6e"
import script from "./BasePotentialBidder.vue?vue&type=script&lang=js"
export * from "./BasePotentialBidder.vue?vue&type=script&lang=js"
import style0 from "./BasePotentialBidder.vue?vue&type=style&index=0&id=6c058d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports